import React from 'react';

const Spinner = (props) => {
    return (
        <div className="loading-spinner">
            
        </div>
    )
}

export default Spinner;